<template>
   <div class="chart-guide">
      <NotFound v-if="!contentData" />
      <div v-if="contentData" id="chart-guide-wrapper" class="main-wrapper chart-guide-wrapper">
         <div class="container-fluid">
            <div class="content">
               <div class="row">
                  <div class="col-md-12 col-lg-9">
                     <div id="markDownContainer" ref="markDownCon" class="main-content-block">
                        <h1 class="mb-3">{{ contentData.header }}</h1>
                        <div
                           class="content-wrapper"
                           v-html="markedRender(contentData.longDescription)"
                        />
                     </div>
                  </div>
                  <div class="col-md-12 col-lg-3">
                     <aside>
                        <div id="sidebar-wrapper">
                           <!-- <h4>Overview</h4> -->
                           <div class="spy-link-wrapper" />
                        </div>
                     </aside>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <Accordion v-if="faq" :config="faq" />
   </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import metaGenerator from '../../util/meta.js';
import NotFound from '../NotFound';
import Poc from '../../components/core/Poc.vue';
import Accordion from '../../components/pricing/Accordion.vue';

export default {
   name: 'ChartGuideDetails',
   components: {
      NotFound,
      Accordion,
   },
   data() {
      return {
         hcSticky: null,
         gumshoe: null,
         sideSticky: null,
         ...(process.browser && { mixpanelChartGuidesTracker: this.$tracker.chartGuides }),
      };
   },

   computed: {
      ...mapState(['chartGuideSlugPageData']),

      contentData() {
         return this.chartGuideSlugPageData && this.chartGuideSlugPageData.content[0];
      },
      faq() {
         return this.chartGuideSlugPageData && this.chartGuideSlugPageData.content[1];
      },
   },

   watch: {
      async $route() {
         const [{ props }] = this.$route.matched;
         await this.$store.dispatch('CHART_GUIDE_SLUG_PAGE_DATA_FETCH', {
            slug: props.default.chartGuide,
         });
      },
   },

   asyncData({ store, route }) {
      const [{ props }] = route.matched;
      return store.dispatch('CHART_GUIDE_SLUG_PAGE_DATA_FETCH', {
         slug: props.default.chartGuide,
      });
   },

   metaInfo() {
      return metaGenerator(this.chartGuideSlugPageData);
   },

   mounted() {
      if (this.chartGuideSlugPageData) {
         this.addHeightToTabInfo();
         this.addTargetBlank();
         this.tabToggleActions();
         this.createPageSectionNav();

         this.$store.commit('SET_SIDEBAR_FLAG', {
            data: true,
         });
      }
      setTimeout(this.Poc.update, 1000);
      this.mixpanelChartGuidesTracker.visited();
   },

   created() {
      if (!this.chartGuideSlugPageData) {
         throw Object.assign(new Error(), {
            code: 404,
            message: 'Chart Guide NOT FOUND',
         });
      }
   },

   destroyed() {
      this.destroySideSticky();
   },

   updated() {
      this.createPageSectionNav();
      setTimeout(this.Poc.update, 1000);
      setTimeout(this.addHeightToTabInfo, 1000);
      this.tabToggleActions();
   },

   methods: {
      addTargetBlank() {
         const content = document.getElementById('chart-guide-wrapper');
         const links = content.getElementsByTagName('a');

         for (let i = 0, linksLength = links.length; i < linksLength; i++) {
            if (links[i].hostname !== window.location.hostname) {
               links[i].setAttribute('target', '_blank');
            }
         }
      },

      tabToggleActions() {
         const dt = document.querySelectorAll('.tab-list dt');
         for (let a = 0, l = dt.length; a < l; a += 1) {
            dt[a].addEventListener('click', e => {
               const { srcElement } = e;
               const activatedElement = srcElement.parentNode.querySelector('dt.active');
               activatedElement && activatedElement.classList.remove('active');
               srcElement && srcElement.classList.add('active');
               this.addHeightToTabInfo();
            });
         }
      },

      createPageSectionNav() {
         const container = document.querySelector('#chart-guide-wrapper aside .spy-link-wrapper');

         container.innerHTML = '';
         this.Poc && this.Poc.$destroy();

         let prevItem = this.$refs.markDownCon.querySelectorAll('h2, h3');
         const pocArr = [];
         prevItem.forEach(node => {
            if (node.tagName === 'H3') {
               const nodeText = node.innerText;
               if (prevItem.tagName === 'H2') {
                  // make prevItem parent and add it inside
                  if (!pocArr[pocArr.length - 1].children) {
                     pocArr[pocArr.length - 1].children = [
                        {
                           header: nodeText,
                           id: node.id,
                        },
                     ];
                  } else {
                     pocArr[pocArr.length - 1].children.push({
                        header: nodeText,
                        id: node.id,
                     });
                  }
               } else {
                  // add inside parent
                  pocArr[pocArr.length - 1].children.push({
                     header: nodeText,
                     id: node.id,
                  });
               }
               prevItem = node;
            } else if (node.tagName === 'H2') {
               // make it a prent
               pocArr.push({
                  header: node.innerText,
                  id: node.id,
               });
               prevItem = node;
            }
         });

         if (pocArr.length > 1) {
            const ComponentClass = Vue.extend(Poc);
            const instance = new ComponentClass({
               propsData: { items: pocArr },
            });

            instance.$mount();
            container.appendChild(instance.$el);
            this.Poc = instance;
            this.initSideSticky();
         } else {
            this.Poc && this.Poc.$destroy();
         }
      },

      initSideSticky() {
         if (this.sideSticky) {
            this.destroySideSticky();
         }
         // eslint-disable-next-line
         this.sideSticky = new hcSticky('#sidebar-wrapper', {
            top: 60,
         });
      },

      destroySideSticky() {
         if (this.hcSticky && this.sideSticky) this.sideSticky.destroy();
      },

      addHeightToTabInfo() {
         if (window.innerWidth >= 800) {
            const dtActive = document.querySelectorAll('.tab-list dt.toggleitemhead.active');
            dtActive.forEach(a => {
               const dts = a.parentNode.querySelectorAll('dt');
               let elHeight = 0;
               dts.forEach(b => {
                  elHeight += b.offsetHeight;
               });
               if (elHeight < a.nextElementSibling.offsetHeight) {
                  a.parentNode.style.height = `${a.nextElementSibling.offsetHeight + 20}px`;
               } else {
                  a.parentNode.style.height = `${elHeight + 20}px`;
               }
            });
         }
      },
   },
};
</script>
<style lang="scss" scoped>
@import '../../util';
.main-wrapper {
   width: 100%;
}

.main-layout {
   display: flex;
   flex-flow: column nowrap;

   @include media-breakpoint-up(lg) {
      flex-flow: row nowrap;
   }
   @include media-breakpoint-up(xl) {
      flex-flow: row nowrap;
   }
}

.content {
   padding: 30px 0;

   @include media-breakpoint-up(sm) {
      padding: 30px;
   }

   @include media-breakpoint-up(md) {
      padding: 50px 30px 30px 30px;
   }

   @include media-breakpoint-up(lg) {
      padding: 50px 30px 50px 30px;
   }
}
</style>

<style lang="scss">
.chart-guide {
   flex: 1;
}
.chart-guide-wrapper {
   background-color: #f8f9fd;
   padding-top: 10px;
   img {
      width: 100%;
      height: auto;
      background: #fff;
      border: 1px solid #ececec;
      padding: 20px;
      border-radius: 4px;
   }
   h1 {
      // margin-top: 2rem;
      margin-bottom: 1rem;
      &:first-of-type {
         margin-top: 0;
      }

      &#line-charts {
         display: none;
      }
   }
   h2 {
      margin-bottom: 2rem;
   }

   h4 {
      font-size: 19px;
      font-size: 1.9rem;
      margin-top: 2rem;
      font-family: basefontSemiBold, Helvetica Neue, Arial, sans-serif;
   }

   h5 {
      font-size: 16px;
      font-size: 1.6rem;
      margin-top: 2rem;
      font-family: basefontSemiBold, Helvetica Neue, Arial, sans-serif;
   }
   p > img {
      width: 100%;
      height: auto;
      max-width: 740px;
      background: #fff;
      border: 1px solid #ececec;
      padding: 20px;
      border-radius: 4px;
      & + em {
         display: block;
         text-align: center;
         font-size: 14px;
         line-height: 1.3;
         font-style: normal;
         max-width: 90%;
         margin: 0.2rem auto 0;
      }
   }

   ul {
      margin-bottom: 3rem;
   }

   .tab-list {
      padding-left: 0;
      margin: 3rem 0;
      position: relative;
      dt {
         padding: 10px 15px;
         font-weight: 300;
         font-size: 16px;
         line-height: 1.2;
         cursor: pointer;
      }
      dd {
         padding: 5px;
         // height: 100%;
         margin-bottom: 1rem;
         max-width: 550px;
         img {
            max-height: 100%;
         }
      }
      dt {
         width: 100%;
         color: #434456;
         margin-top: 5px;
         border-radius: 4px;

         &.active {
            color: #fff;
            background-color: #6957da;
            & + dd {
               display: block;
            }
         }
      }
      dd {
         width: 100%;
         display: none;
         color: #434456;
         p {
            margin-top: 0;
         }

         img {
            max-width: 100% !important;
            height: auto;
            background: #fff;
            border: 1px solid #ececec;
            padding: 20px;
            border-radius: 4px;
            & + em {
               display: block;
               text-align: center;
               font-size: 14px;
               line-height: 1.3;
               font-style: normal;
               max-width: 100%;
               margin: 0.2rem auto 0;
            }
         }
      }
   }

   blockquote {
      background-clip: border-box;
      background-color: #fff;
      border: 0 solid rgba(49, 49, 49, 0.125);
      border-radius: 0.5rem;
      padding: 25px;
      box-shadow: 0 2px 10px 0 rgba(33, 35, 68, 0.05) !important;
      margin-bottom: 3rem;
      h4 {
         margin-top: 0;
      }
      p:last-child {
         margin: 2rem 0 0;
      }

      a {
         display: inline-block;
         background: #2cc7c0;
         background: -webkit-linear-gradient(0deg, #2cc7c0, #59d99d);
         background: linear-gradient(90deg, #2cc7c0, #59d99d);
         border: none;
         box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;
         color: #fff;
         border: 1px solid transparent;
         border-radius: 0.5rem;
         display: inline-block;
         font-family: basefontSemiBold, Helvetica Neue, Arial, sans-serif;
         font-size: 15px;
         font-size: 1.5rem;
         line-height: 1;
         line-height: 1.65;
         padding: 0.7rem 1.55rem;
         text-align: center;
         text-transform: uppercase;
         transition: all 0.35s ease;
         user-select: none;
         vertical-align: middle;
         white-space: nowrap;
         &:hover,
         &:active {
            text-decoration: none;
            background: #25a8a2;
            background: -webkit-linear-gradient(0deg, #25a8a2, #3ad28b);
            background: linear-gradient(90deg, #25a8a2, #3ad28b);
            color: #fff;
         }
      }
   }

   @media (min-width: 800px) {
      .tab-list {
         position: relative;
         // min-height: 450px;
         dt {
            width: 25%;
         }
         dd {
            width: 70%;
            position: absolute;
            top: 0;
            left: 30%;
         }
      }
   }

   aside {
      height: 100%;
      border-left: 1px solid rgba(62, 57, 107, 0.04);
      padding-left: 25px;
      h4 {
         padding-left: 13px;
         font-size: 16px;
         color: #73748c;
         text-transform: uppercase;
      }
      .spy-link-wrapper {
         height: 75vh;
         overflow: auto;
      }
      ul {
         list-style: none;
         padding: 0;
         margin: 0;
         li {
            margin-bottom: 1rem;
            line-height: 1.2;
            a {
               color: #73748c;
               font-size: 14px;
               display: block;
               padding-left: 8px;
               &:hover {
                  text-decoration: none;
                  color: #212344;
               }
               &.active {
                  color: #212344;
                  font-weight: 600;
               }
               &.asideh1 {
                  font-size: 16px;
                  font-weight: 600;
                  padding-left: 0;
                  color: #4e4f5f;
                  &.active {
                     color: #212344;
                     font-weight: 600;
                  }
               }
            }
         }
      }
   }
   .two-col-container {
      padding-left: 0;
      padding-right: 0;
      .col-md-6 {
         img {
            height: 100%;
            width: 100%;
         }
      }
   }
}
</style>
